import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import JobZImage from "../../../../common/jobz-img";
import { publicUser } from "../../../../../globals/route-names";
import { useTranslation } from "react-i18next";
import axiosInstance from '../../../../../axiosInstance';
import { API_URL } from "../../../../../config";
import { toast } from "react-toastify";
import { Helmet } from 'react-helmet-async';

function ResetPasswordPage() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const emailFromQuery = queryParams.get("email");

    const email = location.state?.email || emailFromQuery || "";
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            toast.error('New password and confirm password do not match.');
            return;
        }

        setLoading(true);

        try {
            const response = await axiosInstance.post(`${API_URL}/resetPassword`, {
                email,
                newPassword: password
            });
            toast.success(response.data.message || 'Password reset successful.');
            setTimeout(() => {
                navigate("/login");
            }, 1500);

        } catch (err) {
            console.error(err);
            if (err.response) {
                toast.error(err.response.data.message || 'Something went wrong.');
            } else {
                toast.error('Something went wrong, please try again later.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Helmet>
                <title>Reset-Password | CV Diffusion</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>
            <div className="section-full site-bg-white">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-8 col-lg-6 col-md-5 twm-log-reg-media-wrap">
                            <div style={{paddingTop: '0px'}} className="twm-log-reg-media">
                                <JobZImage src="images/login-bg.png" alt="" />
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-7">
                            <div className="twm-log-reg-form-wrap">
                                <div className="twm-log-reg-logo-head">
                                    <NavLink to={publicUser.HOME1}>
                                        <JobZImage src="images/skins-logo/logo-skin-5.png" alt="" className="logo" />
                                    </NavLink>
                                </div>
                                <div className="twm-log-reg-inner">
                                    <div className="twm-log-reg-head">
                                        <span className="log-reg-form-title">{t("Reset Password")}</span>
                                    </div>
                                    <div className="mt-3 mb-3">
                                        <span>{t("Your new password must be different from previously used passwords.")}</span>
                                    </div>
                                    <div className="twm-tabs-style-2">
                                        <div className="tab-content">
                                            {/* {message && <Alert variant="success">{message}</Alert>}
                                            {error && <Alert variant="danger">{error}</Alert>} */}
                                            <form onSubmit={handleSubmit} className="tab-pane fade show active" id="twm-login-candidate">
                                                <div className="form-group mb-3">
                                                    <label style={{ display: 'block', textAlign: 'left', marginBottom: '4px' }} htmlFor="NewPasswordInput">{t("New Password")} :</label>
                                                    <input
                                                        id="NewPasswordInput"
                                                        name="New Password"
                                                        type="password"
                                                        className="form-control"
                                                        placeholder={`${t("Enter your new password")}*`}
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)} />
                                                </div>

                                                <div className="form-group mb-3">
                                                    <label style={{ display: 'block', textAlign: 'left', marginBottom: '4px' }} htmlFor="ConfirmPasswordInput">{t("Confirm Password")} :</label>
                                                    <input
                                                        id="ConfirmPasswordInput"
                                                        name="Confirm Password"
                                                        type="password"
                                                        className="form-control"
                                                        placeholder={`${t("Enter the confirm password")}*`}
                                                        value={confirmPassword}
                                                        onChange={(e) => setConfirmPassword(e.target.value)} />
                                                </div>
                                                <div className="form-group">
                                                    <button type="submit" className="site-button" disabled={loading}>
                                                        {loading ? `${t("Resetting")}...` : `${t("Set New Password")}`}
                                                    </button>
                                                </div>
                                            </form>
                                            <div className='flex justify-center items-center site-text-primary mb-3'>
                                                <NavLink to={publicUser.pages.LOGIN}>
                                                    <i className="fa fa-arrow-left" />
                                                    <span className="site-text-primary ms-2">{t("Back to Login")}</span>
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div></>
    );
}

export default ResetPasswordPage;
